module.exports = __webpack_public_path__ + "static/media/2019-Raptor.3726df46.jpg";